import Paper from '@material-ui/core/Paper';
import React from 'react';
import Button from '../../../../components/Button';

interface IProps {
  onCancel: () => void;
  onContinue: () => void;
}

const EventWithdraw = ({ onContinue, onCancel }: IProps) => (
  <div className="event-checkout wrapper">
    <div className="event-withdraw">
      <Paper elevation={1} className="paper">
        <div className="stats-content">
          <h4>CONFIRM WITHDRAWAL FROM THIS EVENT</h4>
          <div className="paragraph">
            Withdrawing from this event is subject to the policies of your club. For questions,
            speak with your event director.
          </div>
          <Button
            className="button button-shadow"
            variant="contained"
            color="primary"
            onClick={onCancel}
          >
            NO, I WANT TO PLAY
          </Button>
          <Button className="button" variant="outlined" color="primary" onClick={onContinue}>
            YES, I WANT TO WITHDRAW
          </Button>
        </div>
      </Paper>
    </div>
  </div>
);

export { EventWithdraw };
